import { NavLink } from "react-router-dom";
import { FRAMEWORK_META } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const ORDER = ["dinacharya", "panchatanthra", "viveka_kartha"];
const INK = {
  dinacharya: "data-[on=true]:bg-[hsl(186_74%_30%)]",
  panchatanthra: "data-[on=true]:bg-[hsl(20_86%_47%)]",
  viveka_kartha: "data-[on=true]:bg-[hsl(288_46%_42%)]",
};

/** One-click hop across the three frameworks — no navigation panel needed while presenting. */
export const FrameworkSwitcher = ({ current }) => {
  const { access } = useAuth();
  const available = ORDER.filter((fw) => (access?.frameworks || []).includes(fw));
  if (available.length < 2) return null;

  return (
    <div className="panel inline-flex items-center gap-1 p-1.5" data-testid="framework-switcher">
      {available.map((fw) => {
        const meta = FRAMEWORK_META[fw];
        const on = fw === current;
        return (
          <NavLink
            key={fw}
            to={`/${meta.path}`}
            data-on={on}
            data-testid={`switch-to-${fw}`}
            className={`rounded-lg px-4 py-2 text-[11px] uppercase tracking-[0.14em] transition-colors duration-300 ${
              on ? `text-white ${INK[fw]}` : "text-muted-foreground hover:bg-navy/[0.05] hover:text-navy"
            }`}
          >
            {meta.name}
          </NavLink>
        );
      })}
    </div>
  );
};
